import { Component, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {PartnerOffer} from 'src/app/shared/models/data.model'
import { _windowUtil } from '../../utils/ui-utils';
import { properties } from 'src/environments/properties';
import { ParamService } from '../../services/param.service';

@Component({
  selector: 'app-partnerscard',
  templateUrl: './partnerscard.component.html',
  styleUrls: ['./partnerscard.component.scss']
})
export class PartnerscardComponent implements OnInit {

  banner: string;
  
  @Input() offer: PartnerOffer;
  @Input() partnersInfoDefaultView: boolean;
  @Input() userInfo: any;
  @Input() cardIndex: number;
  @Input() configObj?: any = {
    programType: '',
    appName: ''
  };
  @Input() enableClaimOfferCTA: boolean;
  
  public windowUtil = _windowUtil(window);
  partnersOfferDisplay: PartnerOffer;
  displayCard: boolean = false;

  scrWidth : any;
  viewPort = 'desktop';
  imageAltText: string = '';
  
  enablePartnerOffersDynamicFlow: boolean = false;
  constructor(public elementRef: ElementRef,
     private router: Router,
      public paramService: ParamService) {
        this.banner = this.paramService.banner;
        const partnerPromotionBannerConfig = properties.featureFlags.partnerPromotionBannerConfig;
        this.enablePartnerOffersDynamicFlow = properties.featureFlags.enablePartnerOffersDynamicFlow && partnerPromotionBannerConfig[this.banner] === true;
  }

  ngOnInit(): void {
    if (this.offer) {
      this.partnersOfferDisplay = this.normalizePartnerOffer(this.offer);
      if(!this.enablePartnerOffersDynamicFlow){
        this.checkIfOfferCanBeClaimed();
      }
      this.displayCard = true;
    }
  }
  @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
      this.scrWidth = window.innerWidth;
      if(this.scrWidth >= 768) {
          this.viewPort = 'desktop';
      } else{
          this.viewPort = 'mobile';
      }
      this.setPartnerImage();
    }

    ngAfterViewInit() {
      this.setPartnerImage();
    }

    setPartnerImage() {
      const imgElement = this.elementRef.nativeElement.querySelector('.partners-offer-img');
        if (imgElement) {
            imgElement.style.backgroundImage = this.getImageUrl(this.viewPort);
            imgElement.style.backgroundRepeat = 'no-repeat';
            imgElement.style.backgroundSize = '100% 100%';
        }
    }

    public getImageUrl(viewport: string): string {
      let imageRef = '';
      let imgPath = '';
      const bgImgPath = this.enablePartnerOffersDynamicFlow ? this.partnersOfferDisplay?.bgImgPath : this.partnersOfferDisplay?.bgImgFileReference;
      if (bgImgPath) {
          const modifiedImagePath = bgImgPath?.replace(/\$.*/, '');
          if (viewport === 'desktop') {
              imgPath = '?$partner-cards-desktop$&defaultImage=Not_Available';
          } else {
              imgPath = '?$partner-cards-tablet$&defaultImage=Not_Available';
          }
          imageRef = 'url(' + modifiedImagePath + imgPath + ')'
      }
      return imageRef;
    }

  private normalizePartnerOffer(offer: PartnerOffer): PartnerOffer {
    return {
      title: offer.title || '',
      subTitle: offer.subTitle || '',
      ctaText: offer.ctaText || '',
      includedBanners: offer.includedBanners || [],
      startDate: offer.startDate || '',
      endDate: offer.endDate || '',
      displayOrder: offer.displayOrder || '',
      partnerProgramType: offer.partnerProgramType || '',
      bannerType: offer.bannerType || '',
      userTypes: offer.userTypes || [],
      ctaLink: offer.ctaLink || '',
      bgImgPath: offer.bgImgPath || '',
      bgImgAltText: offer.bgImgAltText || '',
      ctaLinkMobile: offer.ctaLinkMobile || '',
      enableCta:offer?.enableCta || false,
      isOfferRedeemed: offer?.isOfferRedeemed || false,
      contentPath: offer.contentPath || '',
      partnerOfferId: offer.partnerOfferId || '',
      isStatic: offer.isStatic || false,
      staticPromo: offer.staticPromo || '',
      partnerExternalUrl: offer.partnerExternalUrl || '',
      bgImgFileReference: offer.bgImgFileReference || '',
    };
  }

  checkIfOfferCanBeClaimed() {
    if (this.enableClaimOfferCTA && this.partnersOfferDisplay.ctaText && this.partnersOfferDisplay.ctaLink) {
      this.enableClaimOfferCTA = true;
    } else {
      this.enableClaimOfferCTA = false;
    }
  }

  onClickCTA(event) {
    if (!this.enablePartnerOffersDynamicFlow) {
      if (event instanceof KeyboardEvent && event.key !== 'Enter') {
        return;
      }
      if (window['AB'] && window['AB']['DATALAYER']) {
        const linkName = event.target.classList.contains('offer-btn-container') || event.target.classList.contains('offerClaimCTA') ? `:${this.partnersOfferDisplay.ctaText?.toLowerCase()?.replace(/ /g, '-')}` : '';
        window['AB']['DATALAYER'].setLinkClickEvents(`for-u-partner-offers|${this.partnersOfferDisplay.title?.toLowerCase()?.replace(/ /g, '-')}${linkName}`, true);
      }
    }else{
      const { contentPath, partnerOfferId, isStatic, staticPromo, partnerExternalUrl } = this.partnersOfferDisplay;
      const storageData = {
          contentPath,
          partnerOfferId,
          isStatic,
          staticPromo: staticPromo.trim() === '' ? null : staticPromo,
          partnerExternalUrl,
          userInfo: this.userInfo
      };
      localStorage.setItem('partnerDetails', JSON.stringify(storageData));
      this.windowUtil.setWindowLocationHref('rewards/partner-detail.html?freshpass=true');
    }
  }
}
